import { _forEachName } from 'gsap/gsap-core';
import $ from 'jquery'

$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(document).ready(function($) {
  $(window).on('scroll load',function() {
    if ( $(window).scrollTop() > 320) {
      $('.go-top').addClass('show');
    } else {
      $('.go-top').removeClass('show');
    }

    if ($(window).scrollTop() > 40) {
      $('.header').addClass('scrolled');
    } else {
      $('.header').removeClass('scrolled');
    }
  });

  if($('.sticky').length > 0) {
    $(window).on('scroll load resize',function() {
      let stickyTop = $('.sticky').offset().top;

      if ($(window).scrollTop() == stickyTop) {
        $('.sticky').addClass('is-sticky');
      } else {
        $('.sticky').removeClass('is-sticky');
      }

      $('.scroll-section').each(function(){
        let sectionTop = $(this).offset().top;

        if ($(window).scrollTop() > sectionTop && $(this).isInViewport()) {
          let section = $(this).data('section');
          $('.sticky a').removeClass('active');
          $('.sticky a[data-container="'+ section +'-row"]').addClass('active')
        }
      });
    });
  }

});


// WEBPACK FOOTER //
// ./resources/assets/js/partial/header.js